<template>
    <div>
        <div class="container-fluid bg-light py-6 mt-0">
          <div class="container text-center animated bounceInDown">
            <h1 class="display-1 mb-4">{{ $t("courses") }}</h1>
            <ol
              class="breadcrumb justify-content-center mb-0 animated bounceInDown"
            >
              <li class="breadcrumb-item">
                <a href="#">{{ $t("home") }}</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">{{ $t("courses") }}</a>
              </li>
              <li class="breadcrumb-item text-dark" aria-current="page" v-if="course.course_category_id == 1">
                {{ $t("beginnerLevel") }}
              </li>
              <li class="breadcrumb-item text-dark" aria-current="page" v-else-if="course.course_category_id == 2">
                {{ $t("elementaryLevel") }}
              </li>
              <li class="breadcrumb-item text-dark" aria-current="page" v-else-if="course.course_category_id == 3">
                {{ $t("intermediateLevel") }}
              </li>
              <li class="breadcrumb-item text-dark" aria-current="page" v-else>
                {{ $t("upperIntermediateLevel") }}
              </li>
            </ol>
          </div>
        </div>
        <div class="container blog py-6 animated bounceInDown">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <img :src="getImageUrl(course.cover_photo_url)" alt="" width="100%" class="mb-3">
              </div>
              <div class="col-md-6">
                <h4>{{ getLocalizedTitle(course) }}</h4>
                <p class="text-bold">{{ getLocalizedSummary(course) }}</p>
              </div>
              <hr>
            </div>
            <div class="col-md-12">
              <p class="ms-4 text-bold" v-html="getLocalizedDescription(course)"></p>
            </div>
            <div class="row">
              <div class="col-md-6 mt-2" v-for="file in course.files" :key="file.id">
                <img :src="getImageUrl(file.url)" alt="" class="img-fluid" style="object-fit: contain;"/>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";
import mediaUrl from "../utils/mediaUrl";

export default {
  props: {
    id: String,
  },
  computed: mapGetters(["course"]),
  methods: {
    ...mapActions(["getCourseDetail"]),
    getImageUrl(imageUrl) {
      return mediaUrl(imageUrl);
    },
    getLocalizedTitle(course) {
      const locale = this.$i18n.locale;
      if (locale === 'en') return course.title_en ? course.title_en : course.title_en;
      if (locale === 'mm') return course.title_mm ? course.title_mm : course.title_mm;
      if (locale === 'jp') return course.title_jp ? course.title_jp : course.title_jp;
    },
    getLocalizedDescription(course) {
      const locale = this.$i18n.locale;
      if (locale === 'en') return course.description_en ? course.description_en : course.description_en;
      if (locale === 'mm') return course.description_mm ? course.description_mm : course.description_mm;
      if (locale === 'jp') return course.description_jp ? course.description_jp : course.description_jp;
    },

    getLocalizedSummary(course) {
      const locale = this.$i18n.locale;
      if (locale === 'en') return course.summary_en ? course.summary_en : course.summary_en;
      if (locale === 'mm') return course.summary_mm ? course.summary_mm : course.summary_mm;
      if (locale === 'jp') return course.summary_jp ? course.summary_jp : course.summary_jp;
    }
  },
  mounted() {
    this.getCourseDetail(this.id);
  },
};
</script>
  
<style></style>
  